import React from 'react';
import OAuthButton from './OAuthButton';

interface OAuthButtonsProps {
  type: 'login' | 'register';
  disabled?: boolean;
  className?: string;
}

export const OAuthButtons: React.FC<OAuthButtonsProps> = ({ 
  type, 
  disabled = false,
  className = '' 
}) => {
  return (
    <div className={`${className}`}>
      {/* OAuth Buttons */}
      <div className="flex items-center justify-center space-x-4">
        <OAuthButton 
          provider="google" 
          type={type} 
          disabled={disabled}
        />
        
        {/* Facebook and Apple buttons hidden but maintained in code */}
        {false && (
          <>
            <OAuthButton 
              provider="facebook" 
              type={type} 
              disabled={disabled}
            />
            
            <OAuthButton 
              provider="apple" 
              type={type} 
              disabled={disabled}
            />
          </>
        )}
      </div>

      {/* Divider */}
      <div className="flex items-center mt-6">
        <div className="flex-1 border-t border-gray-300 dark:border-gray-600"></div>
        <span className="px-4 text-sm text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800">
          ou
        </span>
        <div className="flex-1 border-t border-gray-300 dark:border-gray-600"></div>
      </div>
    </div>
  );
};

export default OAuthButtons;